// Start views //
import AccountView from './accountview';
import AlertView from './alertview';
import ModalView from './modalview';
import FormView from './views/formview';
import TagView from './tagview';
import Select2View from './views/select2view';
// End views //
import GridModel from './models/gridmodel';
// Start Grid models //
import DepartmentModel from './models/departmentmodel';
import LocationModel from './models/locationmodel';
import CareerModel from './models/careermodel';
import TeamModel from './models/teammodel';
import VideoModel from './models/videomodel';
import TitleCaseModel from './models/titlecasemodel';
import UserModel from './models/usermodel';
import MakerModel from './models/makermodel';
// End Grid models //
// Start other models //
import DeptLocCommModel from './models/deptloccommmodel';
import LocationViewModel from './models/locationviewmodel';
import LocationAddressViewModel from './models/locationaddressviewmodel';
import LotModel from './models/lotmodel';
// End other models//
// Start collections //
import GridCollection from './collection/gridcollection';
import DeptLocsCollection from './collection/deptlocscollection';
import DeptLocCommCollection from './collection/deptloccommcollection';
import Countries from './collection/countriescollection';
import States from './collection/statescollection';
import RegStatusList from './collection/registrationstatuscollection';
// End collections //
// Start ViewModel Collection
import UserPwForm from './collection/userpwform';
import UserViewCollection from './collection/userviewcollection';
// End ViewModel Collection

const domainURL = $('body').data('domain');
const apiDomainUrl = $('body').data('apidomain');

// Polyfill for String.startsWith
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.lastIndexOf(searchString, position) === position;
  };
}

// set cookie
function setCookie(cname, cvalue) {
  document.cookie = `${cname}=${cvalue}; expires=0;`;
}

// delete cookie
function delCookie(cname) {
  document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

// check if cookie 'isLoggedIn' exists
// function checkCookie(cname) {
//   var isLoggedIn = getCookie(cname);
//   if (isLoggedIn !== "") {
//     setCookie("isLoggedIn", "true");
//   } else {
//     if (!(window.location.pathname.startsWith("/Account/"))) {
//       $.ajax({
//         type: 'get',
//         url: '/user/logoff',
//         datatype: 'html',
//         success: function () {
//           // window.close;
//           // console.log('successfully logged off');
//           window.location.href = "/Account/Login";
//           // window.location.reload();
//         },
//         error: function () {
//           console.log('error logging off');
//         }
//       });
//     }

//     // setCookie("isLoggedIn", "true");
//   }
// }

// get cookie information to show on UI
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
  }
  return "";
}

var Events = _({}).extend(Backbone.Events);


Backbone.View = (function (View) {
  return View.extend({
    constructor: function (options) {
      this.options = options || {};
      View.apply(this, arguments);
    }
  });
})(Backbone.View);

$(document).ready(function () {
  $('#myModal').on('hidden.bs.modal', function () {
    phillips.Events.trigger("closeModal");
    //$(this).find("#mgmtForm").empty();
    $(this).find('.alert').each(function () {
      $(this).fadeOut();
    });
    $(this).unbind('click');
  });
  setCookie('apiAddress', apiDomainUrl);
  // if (!(window.location.pathname.startsWith("/Account/"))) {
  //   checkCookie("isLoggedIn");
  // }
});

export {
  // Start variables
  Events,
  domainURL,
  apiDomainUrl,
  AccountView,
  AlertView,
  ModalView,
  FormView,
  TagView,
  Select2View,
  GridModel,
  DepartmentModel,
  LocationModel,
  CareerModel,
  TeamModel,
  VideoModel,
  TitleCaseModel,
  UserModel,
  MakerModel,
  DeptLocCommModel,
  LocationViewModel,
  LocationAddressViewModel,
  LotModel,
  GridCollection,
  DeptLocsCollection,
  DeptLocCommCollection,
  Countries,
  States,
  RegStatusList,
  UserPwForm,
  UserViewCollection
};
